import { Footnote, StrapiFootnoteData } from './types';

export const getRelevantFootnotesWithIndex = (
  strapi_ids: string[],
  footnotes: StrapiFootnoteData['footnotes']['nodes'],
): Footnote[] =>
  footnotes
    // filter relevant footnotes
    .filter((footnote) => strapi_ids.includes(footnote.strapi_id))
    // sort footnotes in the order in which they occur in in the content (order of strapi_ids)
    .sort(
      (f1, f2) =>
        strapi_ids.indexOf(f1.strapi_id) - strapi_ids.indexOf(f2.strapi_id),
    )
    .map((footnote, index) => ({
      strapi_id: footnote.strapi_id,
      html: footnote.content.data.childMarkdownRemark.html,
      index: (index + 1).toString(),
    }));
